import { Component, Input } from '@angular/core';
import { Itoggle } from '../../interfaces/itoggle';

@Component({
  selector: 'split-toggle-select',
  templateUrl: './toggle-select.component.html',
  styleUrls: ['./toggle-select.component.scss'],
})
export class ToggleSelectComponent {
  @Input() toggle: Itoggle = {
    opcao1: '',
    opcao2: '',
    name: '',
    id1: '',
    id2: '',
  };
}
